import { useNavigate } from 'react-router-dom';
import { cn } from '@/utils/styles';
import { getL2LightImageUrl } from '@utils/nutrition/getImageUrl';
import { EventTracker } from '@/utils';

interface BoosterandBlockerPageCardProps {
  id: number;
  title: string;
  count: number;
  imageUrl: string;
  'data-testid'?: string;
}

export const BoosterandBlockerPageCard = ({
  id,
  title,
  count,
  imageUrl,
  'data-testid': testId,
}: BoosterandBlockerPageCardProps) => {
  const navigate = useNavigate();
  const stateData = { id };
  const handleClick = () => {
    const normalizedTitle = title.toLowerCase();
    EventTracker.trackEvent(
      'booster',
      `boosterBlockers_${normalizedTitle.replace(/\s+/g, '')}`,
    );
    if (normalizedTitle.includes('plant virus')) {
      navigate('/boosters-and-blockers/plant-virus', { state: stateData });
    } else if (normalizedTitle.includes('blood sugar')) {
      navigate('/boosters-and-blockers/blood-sugar', { state: stateData });
    } else {
      navigate(`/boosters-and-blockers/${id}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'w-full h-20',
        'px-6 py-1 pr-5',
        'rounded-md',
        'bg-white',
        'flex justify-between items-center',
        'text-left',
      )}
      key={id}
      data-testid={testId}
    >
      <div className="flex items-center" data-testid="boosterBlockerPageCard-content">
        <div className="h-16 flex items-center justify-center" data-testid="boosterBlockerPageCard-imageContainer">
          <img
            src={getL2LightImageUrl(imageUrl)}
            alt="Shield icon"
            className="w-16 h-16"
            data-testid="boosterBlockerPageCard-image"
          />
        </div>

        <div className="flex flex-col" data-testid="boosterBlockerPageCard-textContent">
          <h3 className="typography-body-emphasis text-primary" data-testid="boosterBlockerPageCard-title">{title}</h3>
          <p className="typography-caption1 text-primary/70" data-testid="boosterBlockerPageCard-count">
            {count} recommendations
          </p>
        </div>
      </div>
    </button>
  );
};
